<template>
    <v-select
        v-model="currentValue"
        :placeholder="$t('Status selecteren')"
        :options="selectOptions"
        :reduce="reduce"
    />
</template>

<script>

export default {
    name: 'ak-approval-status-select',
    data() {
        return {
            currentValue: null
        }
    },
    props: {
        id: {
            type: String
        },
        value: {
            type: String
        },
        statuses: {
            type: Object|Array,
        }
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    watch: {
        value() {
            if (this.value !== this.currentValue) {
                this.currentValue = this.value;
            }
        },
        currentValue() {
            if (this.value !== this.currentValue) {
                this.$emit('input', this.currentValue);
            }
        }
    },
    computed: {
        selectOptions() {
            if (! this.statuses) {
                return []
            }

            return Object.keys(this.statuses).map(value => {
                return {
                    label: this.statuses[value],
                    value: value,
                }
            })
        }
    },
    methods: {
        reduce(option) {
            return option.value;
        }
    },
    mounted() {
        this.currentValue = this.value;
    }
}
</script>
